import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Observable, Subject } from 'rxjs';
import { CustomDialogComponent } from '../custom-dialog/custom-dialog.component';
import { ModalComponent } from '../modal/modal.component';

@Component({
  selector: 'app-base',
  templateUrl: './base.component.html',
  styleUrls: ['./base.component.css']
})
export class BaseComponent implements OnInit {
  bsModalRef: BsModalRef;
  constructor(private bsModalService: BsModalService) { }

  ngOnInit(): void {
  }

  protected ShowMessage(title: string, content: string, callback?: Action<any>) {
    const subject = new Subject<boolean>();
      const initialState = {
        list: [
          content
        ],
        title: title,
        onClose: callback
      };

      this.bsModalRef = this.bsModalService.show(ModalComponent, {
        initialState,
        animated: true, ignoreBackdropClick: true, backdrop: 'static', keyboard: false
      });
      this.bsModalRef.content.closeBtnName = 'Close';
      this.bsModalRef.content.subject = subject;
    }

    protected ShowCustomMessage(title: string, content: any[], callback?: Action<any>) {
      const subject = new Subject<boolean>();
        const initialState = {
          list: content,
          title: title,
          onClose: callback
        };
    
        this.bsModalRef = this.bsModalService.show(CustomDialogComponent, {
          initialState,
          animated: true, ignoreBackdropClick: true, backdrop: 'static', keyboard: false
        });
        this.bsModalRef.setClass('modal-lg');
        this.bsModalRef.content.closeBtnName = 'Close';
        this.bsModalRef.content.subject = subject;
      }
  
}

export interface Action<T> {
  (item: T): void;
}
